// test2327
(2327 && 0);
